import React from "react";
import { useReportContext } from "./ReportContext";
import { IReportSlide } from "./ReprortContextTypes";
import slideContext from "./SlideContext";
import { createUUID } from "./utils";

const SlideContextProvider = slideContext.Provider;

const Slide = (props: React.PropsWithChildren<{ index: number }>) => {
  const report = useReportContext();
  const currentSlide = React.useRef<IReportSlide>({
    uuid: `${createUUID()}`,
    index: props.index,
    slideProgress: 0,
    slideDefinition: report?.templateSlides?.[props.index],
    isReady: false,
    elements: [],
    addElement: (newElement) => {
      currentSlide.current.elements?.push(newElement);
    },
    onElementReady: (newElement) => {
      newElement.isReady = true;
      currentSlide.current?.checkReadiness?.();
    },
    checkReadiness: () => {
      const slide = currentSlide.current;
      if (slide) {
        if (!slide.isReady && slide.hasRenderedAtLeastOnce) {
          const readyCnt =
            slide.elements?.filter((el) => el.isReady).length || 0;
          const allCnt = slide.elements?.length || 0;
          slide.slideProgress = allCnt === 0 ? 1 : readyCnt / allCnt;
          report?.onSlideProgress?.(slide);
          if (readyCnt === allCnt) {
            slide.isReady = true;
            setTimeout(() => {
              report.onSlideReady?.(slide);
            }, 10);
          }
        }
      }
    },
  });

  React.useEffect(() => {
    // create the slide after all elements of the slide have been set
    if (typeof report !== "undefined") {
      report?.addSlide?.(currentSlide.current);
    }
    if (currentSlide && currentSlide.current) {
      currentSlide.current.hasRenderedAtLeastOnce = true;
      currentSlide.current.checkReadiness?.();
    }
  }, []);

  return (
    <div>
      <h1>Slide</h1>
      <SlideContextProvider value={currentSlide.current}>
        {props.children}
      </SlideContextProvider>
    </div>
  );
};

export default Slide;
